import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SearchStartComponent } from './search-start/search-start.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { ErrorHandlerComponent  } from "./error-handler/error-handler.component";
import {SearchStartV2Component} from "./search-start-v2/search-start-v2.component";
import {SearchResultsV2Component} from "./search-result-v2/search-results-v2.component";
import { CarefindrAiComponent } from './carefindr-ai/carefindr-ai.component';
import {NlsLandingPageComponent} from "./nls-landing-page/nls-landing-page.component";
import {NlsSearchResultV2Component} from "./nls-search-result-v2/nls-search-result-v2.component";
import {IFrameComponent} from "./iframe/iframe.component";
import {ComponentTesterComponent} from "./iframe/component-tester.component";

const routes: Routes = [
  {
    path: 'home',
    component: SearchStartV2Component,
    // component: SearchStartComponent,
  },
  {
    path: '',
    component: SearchStartV2Component,
    // component: SearchStartComponent,
  },
  {
    path: 'search-start-v2',
    component: SearchStartV2Component,
  },
  {
    path: 'search-results',
    component: SearchResultsV2Component,
    // component: SearchResultsComponent,
  },
  {
    path: 'search-results-v2',
    component: SearchResultsV2Component,
  },
  {
    path: 'nls-search-results-v2',
    component: NlsSearchResultV2Component,
  },
  {
    path: 'natural-language-search',
    component: NlsLandingPageComponent,
  },
  {
    path: 'error-handler',
    component: ErrorHandlerComponent,
  },
  {
    path: 'carefindr-ai',
    component: CarefindrAiComponent,
  },
  {
    path: 'iframe-test',
    component: IFrameComponent,
  },
  {
    path: 'component-tester',
    component: ComponentTesterComponent,
  },
  // Test routes for components you want to test in iframe
  {
    path: 'test/search-start-v2',
    component: SearchStartV2Component,
  },
  {
    path: 'test/search-results-v2',
    component: SearchResultsV2Component,
  },
  {
    path: 'test/carefindr-ai',
    component: CarefindrAiComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledNonBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
